module.exports = __webpack_public_path__ + "static/mtsu-logo-2ac0a7d1dd8b510bcfd23557cbebb6b2.png";